import { create } from 'zustand'
import type { Theme, ViewMode, SidebarTab } from '../types'

interface UIStore {
  theme: Theme
  viewMode: ViewMode
  sidebarOpen: boolean
  sidebarTab: SidebarTab
  sidebarWidth: number
  setTheme: (theme: Theme) => void
  toggleTheme: () => void
  setViewMode: (mode: ViewMode) => void
  setSidebarOpen: (open: boolean) => void
  toggleSidebar: () => void
  setSidebarTab: (tab: SidebarTab) => void
  setSidebarWidth: (width: number) => void
}

export const useUIStore = create<UIStore>((set, get) => ({
  theme: (localStorage.getItem('theme') as Theme) || 'light',
  viewMode: 'split',
  sidebarOpen: true,
  sidebarTab: 'files',
  sidebarWidth: 260,
  setTheme: (theme) => {
    localStorage.setItem('theme', theme)
    document.documentElement.classList.toggle('dark', theme === 'dark')
    set({ theme })
  },
  toggleTheme: () => {
    const newTheme = get().theme === 'light' ? 'dark' : 'light'
    get().setTheme(newTheme)
  },
  setViewMode: (mode) => set({ viewMode: mode }),
  setSidebarOpen: (open) => set({ sidebarOpen: open }),
  toggleSidebar: () => set((state) => ({ sidebarOpen: !state.sidebarOpen })),
  setSidebarTab: (tab) => set({ sidebarTab: tab }),
  setSidebarWidth: (width) => set({ sidebarWidth: width }),
}))
